import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFFigure } = createEFPic('/media/x-stream/pc/');

export default function BSlider() {
    const { useEffect, useState, useLang, useRef } = useGlobal();
    const { t } = useLang('xstream');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    // 1. 交互：滑动控制改为触发式
    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 750;

        new ScrollMagic.Scene({
            triggerElement: '.containerBox',
            triggerHook: 1,
            offset: layoutH * 2,
        })
            .setClassToggle('.B_slider', 'enter1')
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: '.containerBox',
            triggerHook: 1,
            offset: layoutH * 3,
        })
            .setClassToggle('.B_slider', 'leave1')
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: '.containerBox',
            triggerHook: 1,
            offset: layoutH * 4,
        })
            .setClassToggle('.B_slider', 'leave2')
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: '.containerBox',
            triggerHook: 1,
            offset: layoutH * 4,
        })
            .on('enter', () => {
                setEnter(true);
            })
            .on('leave', () => {
                setEnter(false);
            })
            .addTo(controller);
    }, []);

    const [enter, setEnter] = useState(false);
    let timer0: any = null;
    let timer1: any = null;
    let timer2: any = null;
    const [xstreamNum, setXstreamNum] = useState(0);
    const [otherNum, setOtherNum] = useState(0);
    const xstreamNumRef = useRef(null);
    const otherNumRef = useRef(null);
    xstreamNumRef.current = () => {
        if (xstreamNum >= 80) {
            clearTimeout(timer0);
            clearInterval(timer1);
        } else {
            setXstreamNum(xstreamNum + 1);
        }
    };
    otherNumRef.current = () => {
        if (otherNum >= 16) {
            clearTimeout(timer0);
            clearInterval(timer2);
        } else {
            setOtherNum(otherNum + 1);
        }
    };
    useEffect(() => {
        const clearTimerAll = () => {
            clearInterval(timer2);
            timer2 = null;
            clearInterval(timer1);
            timer1 = null;
            clearTimeout(timer0);
            timer0 = null;
            xstreamNumRef.current = 0;
            xstreamNumRef.current = 0;
            setXstreamNum(0);
            setOtherNum(0);
        };
        if (enter) {
            timer0 = setTimeout(() => {
                timer1 = setInterval(() => {
                    xstreamNumRef.current();
                }, 800 / 80);

                timer2 = setInterval(() => {
                    otherNumRef.current();
                }, 800 / 16);
            }, 1700);
        } else {
            clearTimerAll();
        }
        return () => {
            clearTimerAll();
        };
    }, [enter]);

    return (
        <div className={`B_slider ${css.B_slider}`}>
            <div className="sliderBox">
                <div className="sec1 sec">
                    <div className="img">
                        <EFFigure name={['03_1.webp', '03_1.jpg']} />
                    </div>
                </div>
                <div className="sec2 sec">
                    <div className="img">
                        <EFFigure name={['03_2.webp', '03_2.jpg']} />
                    </div>
                </div>
                <div className="sec3 sec">
                    <div className="img">
                        <EFFigure name={['03_3.webp', '03_3.jpg']} />
                    </div>
                </div>
                <div className="sec4 sec">
                    <div className="sec4Box">
                        <div className="textBox">
                            <p className="title">{t('section_3_title')}</p>
                            <p className="text">{t('section_3_desc')}</p>
                        </div>
                        <div className="scroll">
                            <p className="capacity">{t('section_3_subtitle')}</p>
                            <div className="top">
                                <div className="topBar">
                                    <div className="colorBar"></div>
                                    <div className="textRight">
                                        <span className="num">{xstreamNum}</span>
                                        <span className="unit">%</span>
                                    </div>
                                </div>
                                <div className="topDes">{t('ecoFlow_power_station')}</div>
                            </div>
                            <div className="bot">
                                <div className="botBar">
                                    <div className="colorBar"></div>
                                    <div className="textRight">
                                        <span className="num">{otherNum}</span>
                                        <span className="unit">%</span>
                                    </div>
                                </div>
                                <div className="botDes">{t('others')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
